// --- Existing code you provided ---
function updateTabIndex(selectedRadio) {
    if (!selectedRadio || selectedRadio.type !== 'radio') return;

    const name = selectedRadio.name;
    const qName = (window.CSS && CSS.escape) ? CSS.escape(name) : name.replace(/"/g, '\\"');
    const groupRadios = document.querySelectorAll(`input[type="radio"][name="${qName}"]`);

    groupRadios.forEach(radio => {
        const wrapper = radio.closest('.bg-choice');
        if (!wrapper) return;

        // Set correct tabindex
        wrapper.setAttribute('tabindex', radio.checked ? '-1' : '0');

        // FIX: Only the checked radio gets .selected
        if (radio.checked) {
            wrapper.classList.add('selected');
        } else {
            wrapper.classList.remove('selected');
        }
    });
}
// --- ADDED: Helper to trigger click and ensure change event ---
function triggerClickAndEnsureChange(radio) {
  if (!radio || radio.type !== 'radio' || radio.disabled) return;

  let changeFired = false;
  const onChangeOnce = () => { changeFired = true; };
  radio.addEventListener('change', onChangeOnce, { once: true });

  // Click the radio so existing handlers run (React onChange, analytics, etc.)
  radio.click();

  // In rare cases if change didn’t fire, dispatch it explicitly.
  if (!changeFired) {
    radio.dispatchEvent(new Event('change', { bubbles: true }));
  }
}

document.addEventListener('keydown', (e) => {
  const key = e.key;
  const isActivateKey = (key === 'Enter' || key === ' ' || key === 'Spacebar');
  const isArrowKey = (
    key === 'ArrowLeft' || key === 'Left' ||
    key === 'ArrowRight' || key === 'Right' ||
    key === 'ArrowUp' || key === 'Up' ||
    key === 'ArrowDown' || key === 'Down' ||
    key === 'Home' || key === 'End'
  );

  if (!isActivateKey && !isArrowKey) return;

  let radio = null;
  let wrapper = null;

  if (e.target.matches('input[type="radio"]')) {
    radio = e.target;
    wrapper = radio.closest('.bg-choice');
  } else if (e.target.matches('label[for]')) {
    const id = e.target.getAttribute('for');
    const el = id && document.getElementById(id);
    if (el && el.type === 'radio') {
      radio = el;
      wrapper = radio.closest('.bg-choice');
    }
  } else if (e.target.matches('.bg-choice')) {
    wrapper = e.target;
    radio = wrapper.querySelector('input[type="radio"]');
  }

  if (!radio) return;

  // --- Existing activation logic (kept) + ADDED: trigger click ---
  if (isActivateKey) {
    e.preventDefault(); // prevent page scroll on Space

    // Use click to mirror mouse behavior and let React handle state.
    triggerClickAndEnsureChange(radio);

    // Keep tabindex consistent for the group
    updateTabIndex(radio);
    return;
  }

  // --- NEW: Arrow/Home/End navigation without changing selection ---
  if (isArrowKey) {
    e.preventDefault();

    const name = radio.name;
    const qName = (window.CSS && CSS.escape) ? CSS.escape(name) : name.replace(/"/g, '\\"');
    const groupRadios = Array.from(document.querySelectorAll(`input[type="radio"][name="${qName}"]`));

    // Gather wrappers in document order
    const wrappers = groupRadios
      .map(r => r.closest('.bg-choice'))
      .filter(Boolean);

    // Focus should behave like Tab: only target wrappers with tabindex="0"
    const focusable = wrappers.filter(w => {
      const r = w.querySelector('input[type="radio"]');
      return r && !r.disabled && w.getAttribute('tabindex') === '0';
    });

    const list = focusable.length ? focusable : wrappers;

    // Current index in the navigation list
    let idx = list.indexOf(wrapper);

    // If current wrapper is not in the list (e.g., checked => tabindex -1),
    // find nearest focusable position based on document order
    if (idx === -1) {
      const wi = wrappers.indexOf(wrapper);
      // Take first focusable at/after current position, else last in list
      idx = list.findIndex((w) => wrappers.indexOf(w) >= wi);
      if (idx === -1) idx = list.length - 1;
    }

    // Compute target index
    let newIdx = idx;
    const isPrev = (key === 'ArrowLeft' || key === 'Left' || key === 'ArrowUp' || key === 'Up');
    const isNext = (key === 'ArrowRight' || key === 'Right' || key === 'ArrowDown' || key === 'Down');

    if (isPrev) {
      newIdx = (idx - 1 + list.length) % list.length; // wrap around
    } else if (isNext) {
      newIdx = (idx + 1) % list.length; // wrap around
    } else if (key === 'Home') {
      newIdx = 0;
    } else if (key === 'End') {
      newIdx = list.length - 1;
    }

    const nextWrapper = list[newIdx];
    if (nextWrapper && typeof nextWrapper.focus === 'function') {
      nextWrapper.focus();
      // Keep tabindex consistent based on currently checked radio
      updateTabIndex(radio);
    }
  }
});

// Existing change logic (kept)
document.addEventListener('change', (e) => {
  if (e.target.matches('input[type="radio"]')) {
    updateTabIndex(e.target);
  }
});

// Existing init logic (kept)
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('input[type="radio"]:checked').forEach(updateTabIndex);
});